import { useEffect, useRef, useState } from "react";

import useSubscriptions from "features/subscriptions/hooks/useSubscriptions";

import type { SubscriptionType } from "common/types";

type Step = "manage" | "success" | "successLarge" | "paymentMethod";

export default function useManageSubscriptionSteps(
  subscriptionType: SubscriptionType,
) {
  const [manageSubscriptionStep, setManageSubscriptionStep] =
    useState<Step>("manage");

  const subscriptions = useSubscriptions();

  //we use this to display the large success screen, only for new subs or reactivation subs
  const isNewOrReactivationRef = useRef<boolean>();

  useEffect(() => {
    if (!isNewOrReactivationRef.current) {
      const subscription = subscriptions[subscriptionType];
      isNewOrReactivationRef.current =
        !subscription || subscription.subscription.status === "cancelled";
    }
  }, [subscriptions]);

  const dialogSize =
    manageSubscriptionStep === "manage" ||
    manageSubscriptionStep === "successLarge"
      ? "xl"
      : "md";

  function goToManageSubscriptionStep(step: Exclude<Step, "successLarge">) {
    if (step === "success" && subscriptionType !== "user") {
      setManageSubscriptionStep(
        isNewOrReactivationRef.current ? "successLarge" : "success",
      );
    } else {
      setManageSubscriptionStep(step);
    }
  }

  return {
    manageSubscriptionStep,
    goToManageSubscriptionStep,
    resetManageSubscriptionStep: () => setManageSubscriptionStep("manage"),
    dialogSize,
  } as const;
}
